const isUpdatePayment = window.location.pathname.match('updatepayment') !== null;
const isAddBilling = window.location.pathname.match('addbilling') !== null;

function updateSubmitButton () {
  let formIsValid = true;
  const $billingForm = $('#billing-form-container');
  const country = $billingForm.find('#countries_select').val() || '';
  const updatePaymentText = $('#update_payment_method').text();
  const addBillingText = $('#add_billing').text();
  const freeTrialText = $('#start_free_trial').text();
  var submitText = $('#payment_please_fill_info').text();

  // Query for Inputs named Joe due to Recurly Workaround for not breaking tabbing on Mobile
  // Therefore it injects the iframe along with a dummy input
  // https://github.com/recurly/recurly-js/blame/f9c46b15da5bd5b0ed4278060fa53d47407437bd/lib/recurly/hosted-field.js#L121
  $billingForm.find('input:visible:not(.optional):not([name="joe"])').each(function (index, element) {
    if (!$(this).hasClass('valid')) {
      formIsValid = false;
    }

    if ($(this).hasClass('invalid')) {
      formIsValid = false;
    }

    if (country.length !== 2) {
      formIsValid = false;
    }
  });

  if (!formIsValid) {
    $billingForm.find('.js-credit_submit')
      .attr('disabled', true)
      .text(submitText);
  } else {
    if (isUpdatePayment) {
      submitText = updatePaymentText;
    } else if (isAddBilling) {
      submitText = addBillingText;
    } else {
      submitText = freeTrialText;
    }
    $billingForm.find('.js-credit_submit')
      .attr('disabled', false)
      .text(submitText);
  }
}

module.exports = updateSubmitButton;
